export type Volume = {
  number: string;
  title: string;
  flag?: string;
  subtitle?: string;
  body: string;
  result: string;
};

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'The System: The 8 Seconds After They Tell You',
    flag: 'The heart of the system',
    subtitle: 'The protocol, the map, the words and the boundaries',
    body: 'Everything the other five volumes run on. The SCREEN → FLAG → ADAPT protocol. The Posture Family Map (nine families, so you adapt by what today\'s class asks of the body, not by the name of the diagnosis). The Script Library — nine situations, word for word, including the one nobody teaches: how to refer out without losing the student. The Student Glossary: what they say, what it is, what it does not mean. And the Refer-Out Signals, at two levels: stop now, or talk after class.',
    result: 'You stop looking for knowledge and start having a sentence.',
  },
  {
    number: '02',
    title: 'Lower Body',
    subtitle: 'Hips, hamstrings, knees, ankles and feet · 10 conditions',
    body: 'Where most yoga injuries actually are: one systematic review found the lower body accounts for nearly two-thirds of musculoskeletal injuries in yoga. Hamstring tendinopathy and strain · Hip labral tear and FAI · Hip osteoarthritis · Outer hip pain and bursitis · Groin and adductor strain · Meniscus injury · Knee osteoarthritis · Patellofemoral pain · Ligament and ACL history · Ankle sprain and plantar fasciitis.',
    result: 'The sit-bone pain your deep folds were making worse now has a variation and a sentence.',
  },
  {
    number: '03',
    title: 'Spine',
    subtitle: 'Lower back, sacroiliac and neck · 10 conditions',
    body: 'The volume teachers reach for most, because it is what students name most. Chronic lower-back pain · Lumbar disc herniation · Sciatica · SI joint pain · Spinal stenosis · Spondylolisthesis · Scoliosis · Neck pain and tension · Cervical disc and radiating arm symptoms · Past neck injury and whiplash.',
    result: '"I have a herniated disc" stops being the sentence that ends your class plan.',
  },
  {
    number: '04',
    title: 'Upper Body',
    subtitle: 'Wrists, elbows and shoulders · 10 conditions',
    body: 'The load nobody counts: every chaturanga, plank and down dog puts body weight through the wrists, dozens of times per class. Carpal tunnel · Wrist pain and tendinopathy · Wrist and thumb arthritis · Previous wrist fracture · Elbow tendinopathy · Hyperextending elbows · Rotator cuff tendinopathy · Rotator cuff tear · Frozen shoulder · Shoulder instability and dislocation history.',
    result: 'You keep the flow moving instead of quietly dropping every arm balance from your teaching.',
  },
  {
    number: '05',
    title: 'Special Populations & the Inversion Decision Matrix',
    subtitle: 'Nine populations — organized by people, not by joints',
    body: 'Pregnancy · Postpartum · Older adults and fall risk · Osteoporosis and osteopenia · High blood pressure and heart conditions · Hypermobility and hEDS · After surgery · Chronic pain · Glaucoma and eye conditions. Plus the Inversion Decision Matrix — because the American Academy of Ophthalmology is explicit that "inversion" includes down dog and bridge, not just headstand.',
    result: 'The pregnant student in your open-level class stops being a problem you hope does not show up.',
  },
  {
    number: '06',
    title: 'The Professional Shield',
    subtitle: 'Scope, consent, intake, incidents and referral',
    body: 'The volume that turns your limits into your strongest professional asset. Mapped, principle by principle, to Yoga Alliance\'s published Scope of Practice — including the requirement for explicit informed consent before any hands-on assist. Intake and waiver templates, documentation that is factual instead of interpretive, and the incident protocol for the day something happens.',
    result: 'Your boundary stops feeling like a gap in your knowledge and starts reading as professionalism.',
  },
];

export const insideEveryVolume: string[] = [
  'Quick Card — what they will say, what to ask, refer-out signals and your key script, on one page',
  'Avoid / Variation — organized by the nine posture families, so you go straight from your class plan to the options',
  'Teach Instead — props, variations, and a note for each style: vinyasa and hot, hatha, yin and restorative, Ashtanga',
  'What to Say — before class, mid-pose, to the whole room, and when you refer out',
  'Reviewed by a licensed health professional',
];
